import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { OrderingListViewModel, UpdateOrderingListCommand, DeleteOrderingListCommand, BudgetFrequency, GetRealizedBudgetResponse, OrderingListClient } from "Api/CoreApi";
import ApiFactory from "Api/ApiFactory";
import store from "Store/index"
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { UserPermission } from '../../../Api/DynamicwebApi';

@Component({
    template: "#ordering-list-detail-template"
})
export default class OrderingListDetailComponent extends mixins(BaseComponent, OrderingListUserMixin) {
    @Prop()
    public detail: OrderingListViewModel;

    @Prop()
    public countOfChilds: number;

    @Prop()
    public userIdentity: string;
    
    public disableControls: boolean = true;
    public disableName : boolean = true;
    public disableBudget : boolean = true;

    public newName: string = '';
    public newBudget: number = 0;
    public newPeriod: number = 0;
    public newCanTransferToNextPeriod: boolean = false;
    public newIgnoreForwardBillingOrder: boolean = false;
    public remainingBudget: number = 0;
    
    confirmDeleteListElement: HTMLElement;
    confirmEmptyCart: HTMLElement;

    public collapsed: boolean = true;
    
    public disableCustomerEditForm: boolean = true;

    async mounted() {
        store.state.orderingList.userIdentity = this.userIdentity;
        this.confirmDeleteListElement = document.getElementById('orderinglistOverview_confirm_delete_list');
        this.confirmEmptyCart = document.getElementById('orderinglistOverview_confirm_empty_cart');

        if (!this.detail.listUserPermission) {
            this.detail.listUserPermission = <UserPermission>{};
            this.detail.listUserPermission.budgetFrequency = BudgetFrequency._0;
            this.detail.listUserPermission.unusedBudgetShouldBeTransferredToNextPeriod = false;
        }

        this.newName = this.detail.name;
        this.newBudget = this.detail.budgetPerMonth;
        this.newPeriod = this.detail.listUserPermission.budgetFrequency;
        this.newCanTransferToNextPeriod = this.detail.unusedBudgetShouldBeTransferredToNextPeriod;
        this.newIgnoreForwardBillingOrder = this.detail.ignoreForwardBillingOrder;
        this.detail.budgetPerMonth

        this.collapsed = true;        
    }

    @Watch('newBudget')
    @Watch('newPeriod')
    private async calulateRemainingBudget() {
        var user = this.detail.userIsolationKey;
        if (!user) {
            user = this.userIdentity;
        }
        let client = await ApiFactory.getOrderingListClient();
        let response = await client.getRealizedBudget(this.detail.id, user);
        this.remainingBudget = this.detail.budgetPerMonth - response.budget.realized;
        console.log("Remaining budget: " + this.remainingBudget);
    }
    
    get hideTr(): boolean{

        if(this.isABCustomer)
            return this.detail.hierarchyType == "ABC";


        if(this.isEmployee)
            return false;
        //don't hide levels for employee - as another level may NOT exists
        // return !this.isEmployee && this.detail.hierarchyType == "ABC";
        // return (this.detail.level > 2 && this.detail.parentUserIsolationKey != this.detail.userHierarchy.rootCustomerNumber) && this.isABCustomer;
    }
    

    toggleCollapse(e: any){
        const self = this;
        const nextLevel = this.detail.level+1;
        let querySelectorAll = '[data-level="{0}"]'.replace('{0}', ''+nextLevel);
        querySelectorAll += '[data-level-parent="{0}"]'.replace('{0}', this.detail.userIsolationKey);

        console.debug('debug: toggle collapse selector: '+querySelectorAll);
        document.getElementById('orderinglistoverviewtable').querySelectorAll(querySelectorAll).forEach(x => {
            x.classList.toggle('in');
        });

        this.collapsed = !this.collapsed;
    }

    
    changeName(){        
        this.disableName = !this.disableName;
        this.newName = this.detail.name;
        this.toggleControls();
    }
    
    changeBudget(){
        this.disableBudget = !this.disableBudget;
        this.newBudget = this.detail.budgetPerMonth;
        this.newPeriod = this.detail.listUserPermission.budgetFrequency;
        this.newCanTransferToNextPeriod = this.detail.unusedBudgetShouldBeTransferredToNextPeriod;
        this.newIgnoreForwardBillingOrder = this.detail.ignoreForwardBillingOrder;
        this.toggleControls();
    }

    disableControlBtns(){
        this.disableName = true;
        this.disableBudget = true;
        this.disableControls = true;
    }

    toggleControls(){
        this.disableControls = !(!this.disableName || !this.disableBudget)
    }
    
    get parentList(){
        return store.state.orderingList.orderingLists.find(x => x.userIsolationKey == this.detail.parentUserIsolationKey);
    }
    
    
    
    async update() {
        store.dispatch.orderingList.updateOrderingList(new UpdateOrderingListCommand({
            id: this.detail.id,
            name: this.newName,
            budget: this.newBudget,
            period: this.newPeriod,
            unusedBudgetShouldBeTransferredToNextPeriod: this.newCanTransferToNextPeriod,
            ignoreForwardBillingOrder: this.newIgnoreForwardBillingOrder,
            userIsolationKey: this.detail.userIsolationKey
        }));
        this.detail.ignoreForwardBillingOrder = this.newIgnoreForwardBillingOrder;
        this.detail.unusedBudgetShouldBeTransferredToNextPeriod = this.newCanTransferToNextPeriod;
        this.disableControlBtns();
        this.calulateRemainingBudget();
    }

    async deleteList() {
        const msg = this.confirmDeleteListElement.innerHTML.replace('{0}', this.detail.name);
        if(confirm(msg)){
            await  store.dispatch.orderingList.deleteOrderingList(new DeleteOrderingListCommand({
                id:this.detail.id
            }));
        }
    }

    async procesItemClick(orderListLink: string) {
        let lastVisitedId = localStorage.getItem("lastVisitedListId");
        console.log("procesItemClick");
        console.log(lastVisitedId);
        console.log(this.detail.id);
        if (lastVisitedId != this.detail.id) {
            const msg = this.confirmEmptyCart.innerHTML;
            if (confirm(msg)) {
                localStorage.setItem("lastVisitedListId", this.detail.id);
                $.ajax({
                    url: orderListLink + "&cartcmd=emptycart",
                    success: function () {
                        window.location.href = orderListLink;
                    }
                });
            }
        } else {
            window.location.href = orderListLink;

        }
        
    }
}

Vue.component('ordering-list-detail', OrderingListDetailComponent);